// Skills Icons
import htmlIcon from "./images/html.svg"
import cssIcon from "./images/css.svg"
import reactIcon from "./images/react.svg"
import jsIcon from "./images/javascript.svg"
import designIcon from "./images/design.svg"
import codeIcon from "./images/code.svg"

// Social Icon
import githubIcon from "./images/github.svg"
import codepenIcon from "./images/codepen.svg"
import dribbbleIcon from "./images/dribbble.svg"
import instagramIcon from "./images/instagram.svg"
import project1 from "./images/p1.svg"
import project2 from "./images/p2.svg"
import project3 from "./images/p3.svg"
import project4 from "./images/p4.svg"
import c from "./images/c++.svg"
import python from "./images/python.svg"
import java from "./images/java.svg"
import me from "./images/me.jpg"
import linkedin from "./images/linkedin.svg"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Jay",
  headerTagline: [
    //Line 1 For Header
    "Learning",
    "Building digital",
    //Line 2 For Header
    "products",
    //Line 3 For Header
    "and experience",
  ],
  //   Header Paragraph
  headerParagraph:
    "Graduate student at Arizona State University",

  //Contact Email
  contactEmail: "jpatel82@asu.edu",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      title: "Covid-19 Cases Tracker", //Project Title - Add Your Project Title Here
      para:
        "Scraping live data with API calls on Disease.sh and representing the current, recovered, and death cases all over the world on the global map with help of map.js. Graphical representation of the behavior of Covid-19 cases globally and well as statistics of the country-wise distribution.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: project1,
      //Project URL - Add Your Project Url Here
      url: "https://covid-19-tracker-18991.web.app/",
    },
    {
      title: "Forward Focus: Career Guidance System", //Project Title - Add Your Project Title Here
      para:
        "Cloud-based software that provides the student with the profile evaluation service and Scholarly materials to appear for competitive exams like GRE, CAT, GMAT, and so on. A Linear SVC model was used to evaluate the profile of the student and provide him with a tentative list of eligible Universities for his preferred course. Online quizzes and mock tests were also granted for preparation.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: project2,
      //Project URL - Add Your Project Url Here
      url: "https://github.com/PrimaSanghvi/ForwardFocus-Cloud-Computing-",
    },
    {
      title: "Harnessing Twitter ‘Big Data’ for Automatic Emotion Identification", //Project Title - Add Your Project Title Here
      para:
        "After providing a reliable emotion identification mechanism with the help of a 2.5 million tweets’ database which comprises execution of two of the most efficient algorithms, LIBLINEAR and MNB(Multinomial naive  Bayes)  we acquire a  reliable system for emotion identification. By this project, we demonstrate that a combination of uni-grams, bi-grams,  sentiment/emotion-bearing words, and parts-of-speech information is most effective for gleaning emotions.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: project3,
      //Project URL - Add Your Project Url Here
      url: "https://github.com/beastjk/Twitter-Big-Data-Analysis",
    },
    {
      title: "HugryKya? : Online Food Delivery System", //Project Title - Add Your Project Title Here
      para:
        "Designed an Online Food Ordering System Prototype where the client can order food from multiple restaurants. Also a portal for restaurant managers where they can manage orders from customers. This project was implemented using a software development cycle and a design document.", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: project4,
      //Project URL - Add Your Project Url Here
      url: "https://github.com/beastjk/HungryKya",
    },
    // {
    //   title: "Project Five", //Project Title - Add Your Project Title Here
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
    //   //Project Image - Add Your Project Image Here
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1534239143101-1b1c627395c5?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8NzZ8fHBhc3RlbHxlbnwwfHwwfA%3D%3D&auto=format&fit=crop&w=400&q=60",
    //   //Project URL - Add Your Project Url Here
    //   url: "http://chetanverma.com/",
    // },
    // {
    //   title: "Project Six", //Project Title - Add Your Project Title Here
    //   para:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text.", // Add Your Service Type Here
    //   //Project Image - Add Your Project Image Here
    //   imageSrc:
    //     "https://images.unsplash.com/photo-1517479149777-5f3b1511d5ad?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MTAyfHxwYXN0ZWx8ZW58MHx8MHw%3D&auto=format&fit=crop&w=400&q=60",
    //   //Project URL - Add Your Project Url Here
    //   url: "http://chetanverma.com/",
    // },

    /*
    If You Want To Add More Project just Copy and Paste This At The End
    ,{
        title: 'Project Five',
        para: 'Something Amazing',
        imageSrc: "",
        url: ''
    }
    */
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne:
    "I am currently pursuing a Master's in Information Technology at Arizona State University. I have profound knowledge of Python, C++, and JavaScript. I also have experience working in frameworks like React JS and Django during my internship. I completed my bachelor's in Information and communication technology at Ahmedabad University. ",
  aboutParaTwo:
    "I completed my internship @ Crest Data Systems as a Software Development Engineering intern. Worked on developing Splunk Base app with a goal to provide smooth migration of any app from Python 2 to Python 3. Got to work on React JS for building UI and python for building Rest API. Worked on scraping the web and visualizing data using Python.",
  aboutParaThree:
    "I have also worked as a Coding Instructor at Campk12. I taught students JavaScript and introduced them to basic concepts of coding. The approach was project-based learning and the projects were in the domain of Artificial Intelligence, 3D gaming, and so on.",
  aboutImage: me,

  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      img: htmlIcon,
    },
    {
      img: cssIcon,
    },
    {
      img: jsIcon,
    },
    {
      img: reactIcon,
    },
    {
      img: designIcon,
    },
    {
      img: codeIcon,
    },
    {
      img: python,
    },
    {
      img: c,
    },
    {
      img: java,
    },
  ],

  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  //   Contact Section --------------

  contactSubHeading: "Let's create your next experience together",
  social: [
    // Add Or Remove The Link Accordingly
    { img: githubIcon, url: "https://github.com/beastjk" },
    {
      img: linkedin,
      url: "https://www.linkedin.com/in/jay-patel-6b8369152/",
    },
    {
      img: instagramIcon,
      url: "https://www.instagram.com/jaypatel_xyz",
    },
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
